import React from 'react';
import './CompanyIntro.css';

function CompanyIntro() {
  return (
    <section id="about" className="section company-intro">
      <div className="container">
        <div className="intro-grid">
          <div className="intro-content">
            <span className="section-tag">About Us</span>
            <h2 className="section-title">Creating Landscapes That Inspire</h2>
            <p className="intro-text">
              Heaven Green Landscaping is a premier landscaping company dedicated to transforming outdoor spaces into beautiful, functional environments. With years of experience in residential and commercial projects, we bring nature and design together to create sustainable landscapes that stand the test of time.
            </p>
            <p className="intro-text">
              Our team of certified landscape architects and horticulturists work closely with clients to understand their vision and deliver exceptional results that exceed expectations.
            </p>
            <button className="btn-primary">Learn More About Us</button>
          </div>
          <div className="intro-image">
            <img
              src="https://images.unsplash.com/photo-1558904541-efa843a96f01?ixlib=rb-4.0.3&auto=format&fit=crop&w=600&h=450&q=80"
              alt="Heaven Green Landscaping Company"
            />
          </div>
        </div>
      </div>
    </section>
  );
}

export default CompanyIntro;